import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Services from "./views/Services.vue";
import Service from "./views/Service.vue";
import Billboard from "./views/Billboard.vue";
import Post from "./views/Post.vue";
import Requests from "./views/Requests.vue";
import Request from "./views/Request.vue";
import Profile from "./views/Profile.vue";
import About from "./views/About.vue";
import NoAccount from "./views/NoAccount.vue";
import NewPost from "./views/NewPost.vue";
import NewRequest from "./views/NewRequest.vue";
import News from "./views/News.vue";
import NewsPost from "./views/NewsPost.vue";
import Locale from "./views/Locale.vue";
import NewBooking from "./views/NewBooking.vue";
import Bookings from "./views/Bookings.vue";
import Booking from "./views/Booking.vue";
import AccountCreation from "./views/AccountCreation.vue";
import Welcome from "./views/Welcome.vue";
import ResetPassword from "./views/ResetPassword.vue";
import Documents from "./views/Documents.vue";

Vue.use(Router);

export default new Router({
  routes: [{
    path: "/",
    name: "login",
    component: Login,
    alias: "/login"
  }, {
    path: "/home",
    name: "home",
    component: Home
  }, {
    path: "/services",
    name: "services",
    component: Services
  }, {
    path: "/services/:id",
    name: "service",
    component: Service
  }, {
    path: "/billboard",
    name: "billboard",
    component: Billboard
  }, {
    path: "/billboard/:id",
    name: "post",
    component: Post
  }, {
    path: "/requests",
    name: "requests",
    component: Requests
  }, {
    path: "/requests/:id",
    name: "request",
    component: Request
  }, {
    path: "/profile",
    name: "profile",
    component: Profile
  }, {
    path: "/about",
    name: "about",
    component: About
  }, {
    path: "/no-account",
    name: "noAccount",
    component: NoAccount
  }, {
    path: "/new-post",
    name: "newPost",
    component: NewPost
  }, {
    path: "/new-request",
    name: "newRequest",
    component: NewRequest
  }, {
    path: "/news",
    name: "news",
    component: News
  }, {
    path: "/news/:id",
    name: "newsPost",
    component: NewsPost
  }, {
    path: "/locale",
    name: "locale",
    component: Locale
  }, {
    path: "/new-booking",
    name: "newBooking",
    component: NewBooking
  }, {
    path: "/bookings",
    name: "bookings",
    component: Bookings
  }, {
    path: "/booking/:id",
    name: "booking",
    component: Booking
  }, {
    path: "/documents",
    name: "documents",
    component: Documents
  }, {
    path: "/account-creation",
    name: "accountCreation",
    component: AccountCreation
  }, {
    path: "/welcome",
    name: "welcome",
    component: Welcome
  }, {
    path: "/reset_password",
    name: "resetPassword",
    component: ResetPassword
  }]
});
